import script from './PreviewSection.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"preview-section"},[_c('div',{staticClass:"preview-section__left"},[(_vm.iconName)?_c('SdsIcon',{class:_vm.iconClass,attrs:{"iconName":_vm.iconName,"isThemed":_vm.isIconThemed,"size":"md"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"preview-section__title capitalize"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('div',{staticClass:"preview-section__right"},[(_vm.badgeText)?_c('SdsBadge',{staticClass:"preview-section__badge",attrs:{"background":"elevation","variant":"primary","styling":"brand","size":"md"}},[_vm._v("\n                "+_vm._s(_vm.badgeText)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.seeMoreRoute)?_c('router-link',{attrs:{"to":_vm.seeMoreRoute}},[_c('div',{staticClass:"preview-section__see-more",on:{"click":function($event){return _vm.$emit('seeMoreClick')}}},[_c('span',{staticClass:"preview-section__see-more-text"},[_vm._v(_vm._s(_vm.seeMoreText ? _vm.seeMoreText : _vm.$t('see more')))])])]):_vm._e()],1)]),_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5ead8595_0", { source: ".preview-section[data-v-5ead8595]{display:flex;justify-content:space-between;align-items:center;padding-block:12px}.preview-section__title[data-v-5ead8595]{margin:0;padding-block:3px;color:var(--system-text-on-elevation-primary);font-family:var(--system-title-default-family);font-size:var(--system-title-default-size);font-weight:700;line-height:var(--system-title-default-line-height);letter-spacing:var(--system-title-default-letter-spacing);text-transform:uppercase;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.preview-section__left[data-v-5ead8595]{gap:8px;flex:1;overflow:hidden}.preview-section__icon[data-v-5ead8595],.preview-section__left[data-v-5ead8595],.preview-section__right[data-v-5ead8595],.preview-section__see-more[data-v-5ead8595]{display:flex;align-items:center}.preview-section__badge[data-v-5ead8595]{margin-right:12px}.preview-section__chevron[data-v-5ead8595]{color:var(--component-button-text-tertiary-default)}.preview-section__see-more-text[data-v-5ead8595]{margin-right:2px;color:var(--system-text-on-elevation-brand-primary);font-family:var(--system-body-default-family);font-size:var(--system-body-default-size);font-weight:600;line-height:var(--system-body-default-line-height);letter-spacing:var(--system-body-default-letter-spacing)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5ead8595";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
